import React, { useState, useCallback } from "react";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Collapse,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

/**
 * Reusable info box component for page descriptions
 * Always collapsible with consistent styling
 *
 * @param {Object} props
 * @param {string} props.title - The title of the info box
 * @param {React.ReactNode} props.children - The content of the info box
 * @param {boolean} [props.defaultExpanded=true] - Initial expanded state
 * @param {Object} [props.style] - Additional styles for the Paper component
 */
const InfoBox = ({ title, children, defaultExpanded = true, style = {} }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  return (
    <Paper
      style={{
        padding: 16,
        marginBottom: 24,
        backgroundColor: "#e3f2fd",
        border: "1px solid #90caf9",
        ...style,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        style={{ cursor: "pointer" }}
        onClick={handleToggle}
      >
        <InfoIcon style={{ color: "#1976d2", marginRight: 12 }} />
        <Typography
          variant="subtitle1"
          style={{ fontWeight: 600, color: "#1976d2", flex: 1 }}
        >
          {title}
        </Typography>
        <IconButton size="small" onClick={handleToggle}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Box mt={2}>{children}</Box>
      </Collapse>
    </Paper>
  );
};

export default InfoBox;
